<template>
  <div class="quarter-column">
      <map-indicator v-for="(indicator, index) in subcategory.indicators" 
        :key="indicator.name | makeID"
        :indicator="indicator"
        :indicatorScore="indicatorScores[index].score"
        >
      </map-indicator>
  </div>
</template>

<script>
import MapIndicator from './MapIndicator';

export default {
  name: 'quarter-column',
  props: ['quarterData', 'subcategory', 'catIndex', 'subcatIndex'],
  components: {
    'map-indicator': MapIndicator,
  },
  computed: {
    indicatorScores() {
      return this.quarterData.categories[this.catIndex].subcategories[this.subcatIndex].indicators;
    },
  },
};
</script>

<style lang="less">
  .quarter-column {
    flex: 1 1 25%;
  }

  .map-score-block {
    box-sizing: border-box;
    height: 23px;
    padding: 1px 1px 2px 1px;
  }
</style>



// WEBPACK FOOTER //
// QuarterColumn.vue?50fb4e69